// components/SectionWrapper.tsx
'use client'

import { cn } from '@inflow/ui/lib/utils'
import { motion } from 'motion/react'
import type { ReactNode } from 'react'
import { fadeUp } from '../base-animations' // Adjust import path as needed

interface SectionWrapperProps {
  title: string
  action?: ReactNode
  children: ReactNode
  className?: string
}

export default function ({ title, action, children, className }: SectionWrapperProps) {
  return (
    <div className={cn('container mx-auto grid max-w-7xl content-center gap-6 p-3 md:p-6', className)}>
      <h2 className="md: text-center text-2xl lg:text-left lg:text-4xl">{title}</h2>

      {/* Main Content Slot */}
      {children}

      {/* Action Slot (Bottom Right) */}
      {action && (
        <motion.div
          className="grid justify-items-center gap-3 lg:justify-items-end"
          variants={fadeUp()}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {action}
        </motion.div>
      )}
    </div>
  )
}
